import { fetch, jsmErrorTransformer } from '@atlassian/eoc-fetch';
const JSM_BASE_URL = '/rest/api/3/myself';
export const fetchJsmUserInfo = () => {
  return fetch(JSM_BASE_URL, {
    exactUrl: true,
    errorTransformer: jsmErrorTransformer
  });
};